module.exports = __webpack_public_path__ + "static/media/badge_health_3.235403b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_health_3.png
// module id = 511
// module chunks = 0